module.exports = __webpack_public_path__ + "/96a9964c92b39da13038c02ace3eea95.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/screenshot_evernote.png
 ** module id = 852
 ** module chunks = 0
 **/